//LIBRARIES
import Auth from 'j-toker';
import { browserHistory } from 'react-router';

//ACTIONS
import * as notifications from './notificationActions';
import { setLandlordLogo, setAccentColor } from './userTypesActions';

//HELPES
import { apiGet, apiPost, apiDelete, apiPostMultipart, apiPut } from '../helpers/ApiHelper';
import { toISO8601DateString } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';

export function showCotenantsForm() {
  return {
    type: 'SHOW_COTENANTS_FORM',
  };
}

export function hideCotenantsForm() {
  return {
    type: 'HIDE_COTENANTS_FORM',
  };
}

export function showPetsForm() {
  return {
    type: 'SHOW_PETS_FORM',
  };
}

export function hidePetsForm() {
  return {
    type: 'HIDE_PETS_FORM',
  };
}

export function showVehiclesForm() {
  return {
    type: 'SHOW_VEHICLES_FORM',
  };
}

export function hideVehiclesForm() {
  return {
    type: 'HIDE_VEHICLES_FORM',
  };
}

export function displayOtherOccupantsForm() {
  return {
    type: 'SHOW_OTHER_OCCUPANTS_FORM',
  };
}

export function hideOtherOccupantsForm() {
  return {
    type: 'HIDE_OTHER_OCCUPANTS_FORM',
  };
}

export function displayIsStudentForm() {
  return {
    type: 'SHOW_STUDENT_FORM',
  };
}

export function displayOccupationForm() {
  return {
    type: 'SHOW_OCCUPATION_FORM',
  };
}

export function showPreviousOccupationForm() {
  return {
    type: 'SHOW_PREVIOUS_OCCUPATION_FORM',
  };
}

export function hidePreviousOccupationForm() {
  return {
    type: 'HIDE_PREVIOUS_OCCUPATION_FORM',
  };
}

export function showLandlordReferenceForm() {
  return {
    type: 'SHOW_LANDLORD_REFERENCE_FORM',
  };
}

export function hideLandlordReferenceForm() {
  return {
    type: 'HIDE_LANDLORD_REFERENCE_FORM',
  };
}

export function showApplicationSending() {
  return {
    type: 'SHOW_APPLICATION_SENDING',
  };
}

function showApplicationDoneSending() {
  return {
    type: 'SHOW_APPLICATION_DONE_SENDING',
  };
}

export function showProofOfIncomeUpload() {
  return {
    type: 'SHOW_PROOF_OF_INCOME_UPLOAD',
  };
}

export function showIdentificationUpload() {
  return {
    type: 'SHOW_IDENTIFICATION_UPLOAD',
  };
}

export function addOrEditApplicant(formData, applicationID) {
  let successMessage = 'Successfully added cotenant';
  if (formData.id) {
    successMessage = 'Successfully edited cotenant';
  }
  return dispatch => {
    return dispatch({
      payload: applicantPayload(formData, applicationID)
        .done(response => {
          dispatch(notifications.showSuccess(successMessage));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

function applicantPayload(formData, applicationID) {
  if (formData.id) {
    return apiPut(
      Auth.getApiUrl() + `/leads/applications/${applicationID}/applicants/${formData.id}`,
      formData
    );
  } else {
    return apiPost(Auth.getApiUrl() + `/leads/applications/${applicationID}/applicants`, formData);
  }
}

export function deleteApplicant(applicantID, applicationID) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() + `/leads/applications/${applicationID}/applicants/${applicantID}`
      )
        .done(response => {
          dispatch(notifications.showSuccess('successfullyDeletedApplicant'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function deleteProofOfIncomeUpload() {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/rental_application/income_document')
        .done(response => {
          dispatch(showProofOfIncomeUpload());
          dispatch(notifications.showSuccess('successfullyDeletedDocument'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function deleteIdentificationUpload() {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/rental_application/identification_document')
        .done(response => {
          dispatch(showIdentificationUpload());
          dispatch(notifications.showSuccess('successfullyDeletedDocument'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function acceptApplicationPayment(token = null, paymentDetails = null) {
  const query = browserHistory.getCurrentLocation().query;

  const application_id = query.application_id || paymentDetails['application_id'];
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
        token: token,
      },
    })
  );
  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/rental_application/preauth_payment/${application_id}`,
        data_clone
      )
        .done(response => {
          dispatch({
            type: 'TENANT_PAYMENTS::PAYMENT_SUCCESS',
            paymentSuccessDetails: response.payment_details,
          });
          return dispatch(notifications.showSuccess('paymentInformationSaved'));
        })
        .catch(error => {
          // TODO: GET ERROR FROM ANDREAs PR
          window.Rollbar.error('Accept Application Payment Error', error);
          console.error('request failed', error);
          dispatch(notifications.showFailure(error));

          if (deepDiver(error, 'responseJSON.paysafe_error_code')) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON.paysafe_error_code,
            });
          } else {
            dispatch({ type: 'TENANT_PAYMENTS::PAYMENT_ERROR', error: error });
          }

          throw Error;
        }),
    });
  };
}

export function makeApplicationFeePayment(token, paymentDetails) {
  const query = browserHistory.getCurrentLocation().query;
  const application_id = query.application_id || paymentDetails['application_id'];
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
        token: token,
      },
    })
  );

  data_clone.application_id = application_id;

  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/rental_application/application_fee_payment/${application_id}`,
        data_clone
      )
        .done(response => {
          const verbiage = `${getTranslatedString(
            'successfullySubmittedPaymentOf'
          )}${' '}${paymentDetails.payment_with_fee.formatted_total}`;
          dispatch({
            type: 'TENANT_PAYMENTS::PAYMENT_SUCCESS',
            paymentSuccessDetails: response.payment_details,
          });
          dispatch(notifications.showSuccess(verbiage));
          return true;
        })
        .catch(error => {
          if (
            deepDiver(error, 'responseJSON.bpms_error_message') &&
            deepDiver(error, 'responseJSON.message')
          ) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON,
            });
            return false;
          }
          if (deepDiver(error, 'responseJSON.paysafe_error_code')) {
            dispatch({
              type: 'TENANT_PAYMENTS::PAYMENT_ERROR',
              error: error.responseJSON.paysafe_error_code,
            });
            return false;
          }
          dispatch({ type: 'TENANT_PAYMENTS::PAYMENT_ERROR', error: error });
          return false;
        }),
    });
  };
}

export function authorizeApplicationPayment(token, paymentDetails) {
  let data_clone = JSON.parse(
    JSON.stringify({
      payment_details: {
        ...paymentDetails,
        token: token,
      },
    })
  );
  data_clone.payment_amount = paymentDetails.payment_amount;
  data_clone.payment_type = paymentDetails.payment_type;

  const query = browserHistory.getCurrentLocation().query;
  const application_id = query.application_id || paymentDetails['application_id'];

  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/rental_application/authorize_payment/${application_id}`,
        data_clone
      )
        .then(response => {
          dispatch({
            type: 'TENANT_PAYMENTS::DISPLAY_PAYMENT_WITH_FEE',
            paymentWithFee: response.payment_with_fee,
          });
          return true;
        })
        .catch(error => {
          if (
            deepDiver(error, 'responseJSON.bpms_error_message') &&
            deepDiver(error, 'responseJSON.message')
          ) {
            dispatch({
              type: 'TENANT_PAYMENTS::ERROR_PAYMENT_AUTHORIZE',
              error: error.responseJSON,
            });
            return false;
          }

          dispatch({
            type: 'TENANT_PAYMENTS::ERROR_PAYMENT_AUTHORIZE',
            error: error,
          });
          return false;
        }),
    });
  };
}

export function toggleApplicationFeePaymentModal(isOpen) {
  return {
    type: 'TOGGLE_APPLICATION_FEE_PAYMENT_MODAL',
    isOpen: isOpen,
  };
}

function storeApplicationID(id) {
  return {
    type: 'STORE_APPLICATION_ID',
    id: id,
  };
}

export function createTenantApplicationForm(
  data,
  propertyId,
  applicationId,
  referrer,
  renewalId,
  hasApplicationFee
) {
  return dispatch => {
    // pet, avatar and id upload
    const multiPartFormData = new FormData();

    if (data.tenant_pets && data.tenant_pets.length > 0) {
      data.tenant_pets.forEach((pet, index) => {
        if (pet.avatar[0] && pet.avatar[0] instanceof File) {
          multiPartFormData.append('pets_photo[' + index + '][avatar]', pet.avatar[0]);
        }
      });
    }

    if (data.avatar && data.avatar[0] && data.avatar[0]['lastModified']) {
      multiPartFormData.append('avatar', data.avatar[0]);
    }

    (data.income_proofs || []).forEach((incomeProof, index) => {
      if (incomeProof.file[0] && incomeProof.file[0] instanceof File) {
        multiPartFormData.append('income_proofs_files[' + index + '][file]', incomeProof.file[0]);
      }
    });

    (data.id_proofs || []).forEach((idProof, index) => {
      if (idProof.file[0] && idProof.file[0] instanceof File) {
        multiPartFormData.append('id_proofs_files[' + index + '][file]', idProof.file[0]);
      }
    });

    if (data['move_in_date']) {
      multiPartFormData.append('desired_move_in_date', toISO8601DateString(data['move_in_date']));
    }

    multiPartFormData.append('property_id', propertyId);

    if (applicationId) {
      multiPartFormData.append('application_id', applicationId);
    }
    if (referrer) {
      multiPartFormData.append('referrer', referrer);
    }

    let url = Auth.getApiUrl() + '/rental_application/create_rental_application';

    if (renewalId) {
      multiPartFormData.append('renewal_id', renewalId);
      url = Auth.getApiUrl() + '/rental_application/create_renewal_application';
    }

    data.birthday = data.dob;
    const formData = JSON.stringify(data);
    multiPartFormData.append('data', formData);
    return dispatch({
      payload: apiPostMultipart(url, multiPartFormData)
        .done(response => {
          dispatch(showApplicationDoneSending());
          if (!hasApplicationFee) {
            dispatch(notifications.showSuccess('applicationSubmitted'));
            dispatch(notifications.explosionCelebration());
            browserHistory.push('/dashboard');
          } else {
            dispatch(toggleApplicationFeePaymentModal(true));
            dispatch(storeApplicationID(response.id));
          }
        })
        .catch(error => {
          dispatch({
            type: 'UPLOAD_ERRORS',
            uploadedFileErrorsArray: error.responseJSON?.file_error_array || [],
          });
          if (error.responseJSON?.error_code) {
            dispatch(
              notifications.showFailure(
                getTranslatedString(
                  `tenantPortal.tenantApplication.${error.responseJSON.error_code}`
                )
              )
            );
          } else {
            dispatch(notifications.showFailure(error));
          }

          dispatch(showApplicationDoneSending());
          console.error('request failed', error);
          return error;
        }),
    });
  };
}

function populateTenantApplication(tenantApplication) {
  return {
    type: 'POPULATE_TENANT_APPLICATION',
    tenantApplication: tenantApplication,
  };
}

function applicationNoLongerAvailable(tenantApplication) {
  return {
    type: 'APPLICATION_NO_LONGER_AVAILABLE',
    applicationAvailable: false,
  };
}

export function getTenantApplication(applicationId, propertyId, renewalId) {
  let query_param = '';
  if (applicationId) {
    query_param = `application_id=${applicationId}`;
  }
  if (renewalId) {
    query_param += `&renewal_id=${renewalId}`;
  }
  return dispatch => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() + `/properties/${propertyId}/rental_applications?${query_param}`
      )
        .done(response => {
          if (response.landlord_logo_url) {
            dispatch(setLandlordLogo(response.landlord_logo_url));
            dispatch(setAccentColor(response.accent_color));
          }
          if (response.birthday) {
            response.dob = response.birthday;
          }
          if (response.startDate) {
            response.startDate = new Date(response.startDate);
          }
          if (response.endDate) {
            response.endDate = new Date(response.endDate);
          }
          if (response.previousStartDate) {
            response.previousStartDate = new Date(response.previousStartDate);
          }
          if (response.previousEndDate) {
            response.previousEndDate = new Date(response.previousEndDate);
          }
          dispatch(populateTenantApplication(response));
        })
        .catch(error => {
          dispatch(applicationNoLongerAvailable());
          console.error('request failed', error);
        }),
    });
  };
}

export function deleteLandlordReference(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/landlord_references/' + id)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyDeletedReference'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function deletePersonalReference(id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + '/leads/personal_references/' + id)
        .done(response => {
          dispatch(notifications.showSuccess('successfullyDeletedReference'));
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

export function verifyProperty(property_id) {
  return dispatch => {
    return apiGet(
      Auth.getApiUrl() + `/landlords/properties/verify/${property_id}`
    ).catch((error, textStatus) => {
      dispatch(notifications.showFailure('thatPropertyDoesNotExist'));
      browserHistory.push('/dashboard');
      console.error(textStatus);
      throw Error;
    });
  };
}

export function setTenantApplication(tenant_application) {
  return { 
    type: 'TENANT_APPLICATION', 
    tenant_application: tenant_application,
   }
}

export function setBlockInstances(block_instances) {
  return { 
    type: 'BLOCK_INSTANCES', 
    block_instances: block_instances,
   }
}